import { IconButton } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { ImageField, FormDataConsumer } from "react-admin";

export const ImageFieldWithRemove = ({ id, source, label, onRemove }) => {
  return (
    <FormDataConsumer label="Value" fullWidth>
      {({ formData }) => {
        if (!formData[source]) {
          return <></>;
        }

        return (
          <div style={{ position: "relative", display: "inline-block" }}>
            <ImageField id={id} source={source} label={label} />
            <IconButton
              onClick={onRemove}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "white",
                color: "red",
              }}
            >
              <ClearIcon />
            </IconButton>
          </div>
        );
      }}
    </FormDataConsumer>
  );
};
